
import { useLayoutEffect } from 'react';
import { useThemeStore, getEffectiveTheme } from '@/features/theme';

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const mode = useThemeStore((s) => s.mode);

  useLayoutEffect(() => {
    const apply = () => {
      document.documentElement.setAttribute('data-theme', getEffectiveTheme());
    };
    apply();
    if (mode === 'system') {
      const mq = window.matchMedia('(prefers-color-scheme: dark)');
      mq.addEventListener('change', apply);
      return () => mq.removeEventListener('change', apply);
    }
  }, [mode]);

  return <>{children}</>;
};
